import React from 'react';
import { ExpandableNode } from '@bingads-webui-react/tree-view';

export const DefaultNodeRenderer = node => (
  <a href={node.href}>
    <span className="customer-account-name-span">{node.name}</span>
    <span className="status-span">{node.status}</span>
    <span className="id-span">{node.number}</span>
  </a>
);

export const SimpleNodeRenderer = (node, nodeRenderer) => (
  <span id={`node-id-${node.id}`}>
    { nodeRenderer(node) }
  </span>
);

export const CustomerAccountNodeRenderer = (node, nodeRenderer, args) => (
  <ExpandableNode node={node} {...args}>
    { SimpleNodeRenderer(node, nodeRenderer) }
  </ExpandableNode>
);
